import { type DrawerTypeValue, drawerType } from '../../../drawerTypes';
import { useGetLalSegments } from '../../../hooks/useGetLalSegments';
import { useSegments } from '../../../hooks/useSegments';
import { useLookalikePagination } from '../components/SegmentsList/hooks/useLookalikePagination';
import { useSegmentPagination } from '../components/SegmentsList/hooks/useSegmentPagination';
import { useLookalikeDrawerActions } from './lookalike/useLookalikeDrawerActions';
import { useLookalikeModal } from './lookalike/useLookalikeModal';
import { useLookalikeSegmentsSelection } from './lookalike/useLookalikeSegmentsSelection';
import { useDrawerActions } from './segments/useDrawerActions';
import { useSegmentSelection } from './segments/useSegmentSelection';
import type { LookalikeDrawerConfig, SegmentsDrawerConfig } from './types';

export type DrawerConfig = SegmentsDrawerConfig | LookalikeDrawerConfig;

export function useGetDrawerConfig(currentDrawerType: 'segments'): SegmentsDrawerConfig;
export function useGetDrawerConfig(currentDrawerType: 'lookalike'): LookalikeDrawerConfig;
export function useGetDrawerConfig(currentDrawerType: DrawerTypeValue): DrawerConfig;
export function useGetDrawerConfig(currentDrawerType: DrawerTypeValue): DrawerConfig {
  switch (currentDrawerType) {
    case drawerType.SEGMENTS:
      return {
        type: drawerType.SEGMENTS,
        useDrawerActions,
        useSegmentSelection,
        useLookalikeModal,
        useSegmentDataFetch: useSegments,
        useSegmentPagination,
      };

    case drawerType.LOOKALIKE:
      return {
        type: drawerType.LOOKALIKE,
        useDrawerActions: useLookalikeDrawerActions,
        useSegmentSelection: useLookalikeSegmentsSelection,
        useSegmentDataFetch: useGetLalSegments,
        useLookalikeModal,
        useSegmentPagination: useLookalikePagination,
      };
  }
}
